// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tVeCz6 {
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));
  height: calc(100vh - 155px);
  min-height: 360px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.tGdnYs {
  margin: 0;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);
  line-height: var(--type-paragraph-lg-regular-line-height, 24px);
  color: var(--ibk-colors-neutral-900, #1f1f1f);
}

.l40zpl {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3, 24px);
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

.ChRMFh {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  margin-bottom: var(--spacing-1-5);
}

.b2NtCK {
  height: 1px;
  background: var(--border-neutral-soft, #e5e7eb);
  margin: var(--spacing-2, 16px) 0;
}

.nu4SMF {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.QUNaxC {
  display: flex;
  align-items: center;
  position: relative;
  min-width: 0;
}

.F9qvj1 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
  min-width: 0;
}

.Ld_GRv {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.cG57Nd {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.QeMkvk {
  width: 24px;
  height: 24px;
}

.bhpEtT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: var(--ibk-colors-primary-orange-500, #d64000);
  color: var(--surface-neutral-white, #ffffff);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.AvrGmY {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid var(--border-neutral-soft, #e5e7eb);
  color: var(--ibk-colors-neutral-600, #999999);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.W6IOlp {
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: 400;
  color: var(--ibk-colors-neutral-900, #1f1f1f);
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}

.Mdp0Zb {
  color: var(--ibk-colors-neutral-600, #999999);
}

.YrxXyX {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  margin-top: 15px;
}

.NHjz3c {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 30px;
  font-size: var(--ibk-typography-fontSizeSm, 14px);
  line-height: var(--type-paragraph-sm-line-height, 16px);
  gap: 8px;
}

.QJp8CG {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  flex-shrink: 0;
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 50%;
}

.gV8MvX {
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  margin-left: var(--spacing-1, 8px);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: right;
  flex: 1;
}

.Xgscxw {
  all: unset;
  box-sizing: border-box;
  margin-left: auto;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Xgscxw:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.pODMF1 {
  width: 16px;
  height: 16px;
}

.A7D9ri {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: var(--radius-xs);
  margin: calc(-1 * var(--spacing-0-5));
  padding: var(--spacing-0-5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.A7D9ri:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.Ng_iNM {
  font-size: var(--type-paragraph-sm-font-size);
  color: var(--text-neutral-soft);
  font-style: italic;
  padding-left: 32px;
  margin-top: var(--spacing-1);
}

.l6vi52 {
  display: block;
  color: var(--ibk-colors-neutral-600, #6b7280);
  font-size: var(--ibk-typography-fontSizeXs, 12px);
  margin-top: var(--spacing-2, 16px);
  font-weight: normal;
}

.m3jXx3 {
  all: unset;
  box-sizing: border-box;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;
  margin-left: var(--spacing-1);
}

.m3jXx3:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.m3jXx3:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-xs);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/NewRechargeSidebar/NewRechargeSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,4DAA4D;EAC5D,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,4DAA4D;EAC5D,oCAAoC;EACpC,iDAAiD;EACjD,8DAA8D;EAC9D,+DAA+D;EAC/D,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;EACzD,4CAA4C;EAC5C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,iDAAiD;EACjD,uDAAuD;EACvD,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,mCAAmC;EACnC,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;EACnC,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,iDAAiD;EACjD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oDAAoD;EACpD,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".summaryCard {\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));\n  height: calc(100vh - 155px);\n  min-height: 360px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.summaryTitle {\n  margin: 0;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);\n  line-height: var(--type-paragraph-lg-regular-line-height, 24px);\n  color: var(--ibk-colors-neutral-900, #1f1f1f);\n}\n\n.summarySteps {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-3, 24px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.summaryDivider {\n  height: 1px;\n  background: var(--border-neutral-soft, #e5e7eb);\n  margin: var(--spacing-2, 16px) 0;\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepWrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n  min-width: 0;\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n  min-width: 0;\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.stepInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.stepIconCompleted {\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconActive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background: var(--ibk-colors-primary-orange-500, #d64000);\n  color: var(--surface-neutral-white, #ffffff);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepIconInactive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border-neutral-soft, #e5e7eb);\n  color: var(--ibk-colors-neutral-600, #999999);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: 400;\n  color: var(--ibk-colors-neutral-900, #1f1f1f);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  min-width: 0;\n}\n\n.stepLabelInactive {\n  color: var(--ibk-colors-neutral-600, #999999);\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  margin-top: 15px;\n}\n\n.stepDataItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  min-height: 30px;\n  font-size: var(--ibk-typography-fontSizeSm, 14px);\n  line-height: var(--type-paragraph-sm-line-height, 16px);\n  gap: 8px;\n}\n\n.stepDataLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  flex-shrink: 0;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 50%;\n}\n\n.stepDataValue {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  margin-left: var(--spacing-1, 8px);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  text-align: right;\n  flex: 1;\n}\n\n.editButton {\n  all: unset;\n  box-sizing: border-box;\n  margin-left: auto;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editButton:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.editIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.clickableStep {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  border-radius: var(--radius-xs);\n  margin: calc(-1 * var(--spacing-0-5));\n  padding: var(--spacing-0-5);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.clickableStep:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.emptyState {\n  font-size: var(--type-paragraph-sm-font-size);\n  color: var(--text-neutral-soft);\n  font-style: italic;\n  padding-left: 32px;\n  margin-top: var(--spacing-1);\n}\n\n.stepDataAnnotation {\n  display: block;\n  color: var(--ibk-colors-neutral-600, #6b7280);\n  font-size: var(--ibk-typography-fontSizeXs, 12px);\n  margin-top: var(--spacing-2, 16px);\n  font-weight: normal;\n}\n\n.viewBeneficiariesLink {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  cursor: pointer;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n  margin-left: var(--spacing-1);\n}\n\n.viewBeneficiariesLink:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n.viewBeneficiariesLink:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryCard": `tVeCz6`,
	"summaryTitle": `tGdnYs`,
	"summarySteps": `l40zpl`,
	"summarySection": `ChRMFh`,
	"summaryDivider": `b2NtCK`,
	"summaryStep": `nu4SMF`,
	"stepWrapper": `QUNaxC`,
	"stepHeader": `F9qvj1`,
	"stepIcon": `Ld_GRv`,
	"stepInfo": `cG57Nd`,
	"stepIconCompleted": `QeMkvk`,
	"stepIconActive": `bhpEtT`,
	"stepIconInactive": `AvrGmY`,
	"stepLabel": `W6IOlp`,
	"stepLabelInactive": `Mdp0Zb`,
	"stepContent": `YrxXyX`,
	"stepDataItem": `NHjz3c`,
	"stepDataLabel": `QJp8CG`,
	"stepDataValue": `gV8MvX`,
	"editButton": `Xgscxw`,
	"editIcon": `pODMF1`,
	"clickableStep": `A7D9ri`,
	"emptyState": `Ng_iNM`,
	"stepDataAnnotation": `l6vi52`,
	"viewBeneficiariesLink": `m3jXx3`
};
module.exports = ___CSS_LOADER_EXPORT___;
